<template>
	<div class="profile-wrapper">
		<div class="title">账号设置</div>
		<div>
			<div class="labelname">绑定手机号</div>
			<div>
			  <el-input v-model="data.mobile" size="medium" placeholder="请输入内容" disabled></el-input>
			  <el-button type="info"  @click="mobileVisible = true">{{data.mobile?'更换手机号':'绑定手机号'}}</el-button>
			</div> 
		</div>
		<div>
			<div class="title">绑定第三方账号</div>
			<div class="tips">绑定第三方帐号，可以直接登录。</div>
			<div class="wechat">
				<div class="icon"><i class="iconfont icon-weixin"></i></div>
				<el-button type="info" class="relieve" @click="unBind" v-if="isbind">解除绑定</el-button>
				<el-button type="info" class="relieve" @click="getQRCode" v-else>绑定微信</el-button>
				<!-- <div class="name" v-if="isbind">ID: 爱迪生</div> -->
			</div>
		</div>
		<div>
			<div class="title">密码设置</div>
			<div class="input-wrapper">
				<el-input value="111111" size="medium" type="password" placeholder="请输入内容" disabled></el-input>
				<el-button type="info" @click="passVisible = true">重置密码</el-button>
			</div>
		</div>
		<el-dialog class="qrcode-dialog" title="扫码绑定微信" width="30%" :visible.sync="codeVisible">
			<el-image style="width: 180px; height: 180px" :src="codeUrl" fit="fill"></el-image>
		</el-dialog>
		<el-dialog title="重置密码" width="30%" :visible.sync="passVisible">
		  <el-form :model="form" ref="form" :rules="rules">
		    <el-form-item prop="password">
		        <el-input v-model="form.password" placeholder="请输入原密码" show-password></el-input>
		    </el-form-item>
		    <el-form-item prop="newPassword">
		        <el-input v-model="form.newPassword" placeholder="请输入新密码" show-password></el-input>
		    </el-form-item>
		    <el-form-item prop="confirmPass">
		        <el-input v-model="form.confirmPass" placeholder="请确认密码" show-password></el-input>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="passVisible = false">取 消</el-button>
		    <el-button size="mini" type="primary" @click="submitPassword">确 定</el-button>
		  </div>
		</el-dialog>
		<el-dialog title="绑定手机号" width="30%" :visible.sync="mobileVisible">
		  <el-form :model="form" ref="form" :rules="rules">
		    <el-form-item prop="mobile">
		        <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
		    </el-form-item>
		    <el-form-item prop="code">
		        <div class="getcode">
		        	<el-input v-model="form.code" placeholder="请输入验证码"></el-input>
		        	<el-button type="warning" class="code-btn" @click="getCode" :disabled="buttonDisable">{{buttonName}}</el-button>
		        </div>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="mobileVisible = false">取 消</el-button>
		    <el-button size="mini" type="primary" @click="submitForm">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
import { getSelfInfo, updateUser,mobileCode,mobileBind,updatePassword,getBindStatus,unbindWechat} from '@/api/personal/index'
import { bindCode } from '@/api/wechat/index'
var index,statusIndex;
export default {
  data () {
	  var validateNewPass = (rule, value, callback) => {
	    if (value !== this.form.newPassword) {
	       callback(new Error('两次输入密码不一致!'));
	    } else {
	      callback()
	    }
	  }
    return {
      data: {},
	  password: '',
	  passVisible: false,
	  mobileVisible:false,
	  codeVisible: false,
	  isbind: 0,
	  codeUrl: '',
	  form:{
	  		mobile: '',
	  		code: '',
			password: '',
	  		newPassword: '',
	  		confirmPass: '',
	  },
	  buttonName: '获取验证码',
	  buttonDisable: false,
	  timeNum: 59,
	  rules: {
	  	mobile:  [{ required:true, message: '请输入手机号',trigger: 'blur'}],
	  		code: [{ required:true, message: '请输入验证码',trigger: 'blur'}],
	  		password: [{ required:true, message: '请输入原密码',trigger: 'blur'}],
	  	newPassword: [{ required:true, message: '请输入新密码',trigger: 'blur'},
	  		{ min: 6, message: '密码长度不低于6位',trigger: 'blur'}],
	  	confirmPass:[{ required:true, message: '请再次填写确认',trigger: 'blur'},
	  		{ validator: validateNewPass,trigger: 'blur'}]
	  }
    }
  },
  methods: {
    async getInfo(){
    	const res = await getSelfInfo()
    	if (res.code === 0) {
    		this.data = res.data
    		this.data.mobile = this.data.mobile?this.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2"):'';
    	} else {
    	  this.$message.error(res.msg)
    	}
    },
	async getCode(){
		this.buttonName = this.timeNum+'s后重新获取'
		this.buttonDisable = true;
		index = setInterval(()=>{ 
			this.timeNum--;		
			this.buttonName = this.timeNum+'s后重新获取';
			
		},1000)
		const res = await mobileCode({mobile:this.form.mobile})
		if (res.code === 0) {
			this.$message.success('验证码发送成功')
		} else {
		  this.$message.error(res.msg)
		}
	},
	submitForm(){
		this.$refs.form.validate(async (valid) => {
		  if (valid) {
			const res = await mobileBind({mobile:this.form.mobile,verfCode:this.form.code})
			if (res.code === 0) {
				this.mobileVisible = false
				this.$message.success('手机号绑定成功')
			} else {
			  this.$message.error(res.msg)
			}
			
		  } else {
			console.log('error submit!!');
			return false;
		  }
		});
	},
	submitPassword(){
		this.$refs.form.validate(async (valid) => {
		  if (valid) {
			const res = await updatePassword({password: this.form.password,newPassword: this.form.newPassword})
			if (res.code === 0) {
				this.passVisible = false
				this.$message.success('密码修改成功')
			} else {
			  this.$message.error(res.msg)
			}
			
		  } else {
			console.log('error submit!!');
			return false;
		  }
		});
	},
	// 获取二维码图片信息
	async getQRCode(){
		this.codeVisible = true
		const res = await bindCode()
		this.codeUrl = res.qrcode
		// 隔2s获取一次扫码状态判定是否登录
		statusIndex = setInterval(()=>{
			this.getStatus(1)
		},2000)
	},
	async getStatus(status){
		const res = await getBindStatus()
		if (res.code === 0) {
			this.isbind = res.data.value
			if(res.data.value == 1&&status){
				this.codeVisible = false
				clearInterval(statusIndex)
				this.$message.success('绑定成功')
			}
		} else {
		  this.$message.error(res.msg)
		}
	},
	async unBind(){
		const res = await unbindWechat()
		if (res.code === 0) {
			this.$message.success('微信解绑成功')
			this.isbind = 0
		} else {
		  this.$message.error(res.msg)
		}
	},
  },
  watch:{
	 timeNum(newval){
		 if(newval==0){
		 	this.buttonName = '获取验证码';
		 	this.buttonDisable = false;
		 	clearInterval(index);
			this.timeNum = 59;
		 }
	 } 
  },
  mounted () {
	this.getInfo()
	this.getStatus()
  },
  destroyed(){
  	clearInterval(index)
  	clearInterval(statusIndex)
  }

}
</script>

<style lang="scss" scoped>
.profile-wrapper{
	padding: 30px 40px 80px;
	.title{
		font-size: 20px;
		font-weight: 800;
	}
	.tips{
		margin-top: 5px;
		color: #C1C1C2;
		font-size: 13px;
	}
	&>div:not(:first-child){
		margin-top: 50px;
		
		.labelname{
			color: #505050;
			font-size: 14px;
			margin: 5px 0;
		}
		.input-wrapper{
			margin-top: 25px;
		}
		.el-input{
			width: 300px;
		}
		/deep/.el-input.is-active .el-input__inner,
		/deep/.el-input__inner:focus{
			border-color: #C0C4CC;
		}
		.el-button--info{
			background-color: #F2F3F5;
			color: #313131;
			border: none;
			margin-left: 10px;
		}
		.wechat{
			margin-top: 20px;
			.icon{
				width: 40px;
				height: 40px;
				border-radius: 5px;
				background-color: #55BA87;
				text-align: center;
				line-height: 40px;
				display: inline-block;
				.iconfont{
					color: #fff;
					font-size: 26px;
				}
			}
			.name{
				color: #C1C1C2;
				display: inline-block;
				vertical-align: text-bottom;
				margin-left: 20px;
			}
			.relieve{
				margin: 0 20px;
				vertical-align: bottom;
			}
		}
	}
	.el-dialog{
		.el-input{
			width: 100% !important;
		}
	}
	.qrcode-dialog{
		/deep/.el-dialog__body{
			text-align: center;
		}
	}
	.getcode{
		position: relative;
		.code-btn{
			position: absolute;
			bottom: 0;
			right: 0;
			background-color: #FF842E;
		}
	}
}	

</style>